"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcTabsGroupBehavior = exports.NOT_LABEL_HEADER_ERROR = exports.NOT_LABELS_ERROR = void 0;
var default_behavior_1 = require("../../../common/models/default-behavior");
var helpers_1 = require("../../../common/helpers");
var common_constants_1 = require("../../../common/constants/common-constants");
var bc_tabs_group_behavior_constants_1 = require("./bc-tabs-group-behavior-constants");
var bc_tabs_group_behavior_constants_2 = require("./bc-tabs-group-behavior-constants");
var bc_tabs_group_behavior_constants_3 = require("./bc-tabs-group-behavior-constants");
var bc_tabs_group_behavior_constants_4 = require("./bc-tabs-group-behavior-constants");
var bc_tabs_group_behavior_constants_5 = require("./bc-tabs-group-behavior-constants");
var bc_tabs_group_behavior_constants_6 = require("./bc-tabs-group-behavior-constants");
var bc_tabs_group_behavior_constants_7 = require("./bc-tabs-group-behavior-constants");
var bc_tabs_group_behavior_constants_8 = require("./bc-tabs-group-behavior-constants");
var bc_tabs_group_behavior_constants_9 = require("./bc-tabs-group-behavior-constants");
var bc_tabs_group_behavior_constants_10 = require("./bc-tabs-group-behavior-constants");
var bc_tabs_group_behavior_constants_11 = require("./bc-tabs-group-behavior-constants");
var bc_tabs_group_behavior_constants_12 = require("./bc-tabs-group-behavior-constants");
var bc_tabs_group_behavior_constants_13 = require("./bc-tabs-group-behavior-constants");
var bc_tabs_group_behavior_constants_14 = require("./bc-tabs-group-behavior-constants");
var bc_tabs_group_behavior_constants_15 = require("./bc-tabs-group-behavior-constants");
var bc_tabs_group_behavior_constants_16 = require("./bc-tabs-group-behavior-constants");
var bc_tabs_group_behavior_constants_17 = require("./bc-tabs-group-behavior-constants");
var bc_tabs_group_behavior_constants_18 = require("./bc-tabs-group-behavior-constants");
var bc_tabs_group_behavior_constants_19 = require("./bc-tabs-group-behavior-constants");
var bc_tabs_group_behavior_constants_20 = require("./bc-tabs-group-behavior-constants");
var bc_tabs_group_behavior_constants_21 = require("./bc-tabs-group-behavior-constants");
exports.NOT_LABELS_ERROR = 'There are no labels in tabs.';
exports.NOT_LABEL_HEADER_ERROR = 'Is not posible to find the labels container. Please review the HTML structure of you component.';
var LEFT_POSITION = 'flex-start';
var RIGHT_POSITION = 'flex-end';
var JUSTIFY_CONTENT = 'Justifycontent';
var SPACE_BETWEEN = 'space-between';
var ORIENTATION = 'orientation';
var BcTabsGroupBehavior = (function (_super) {
    __extends(BcTabsGroupBehavior, _super);
    function BcTabsGroupBehavior() {
        var _this = _super.call(this) || this;
        _this.initialTab = 0;
        _this.currentTabsSelected = 0;
        _this.firsLoad = true;
        _this.tabScrollPosition = 0;
        return _this;
    }
    BcTabsGroupBehavior.setUpAll = function () {
        var tabsElements = Array.from(document.querySelectorAll("div[class^='".concat(bc_tabs_group_behavior_constants_11.MOLECULA, "']")));
        var elements = [];
        for (var _i = 0, tabsElements_1 = tabsElements; _i < tabsElements_1.length; _i++) {
            var element = tabsElements_1[_i];
            var bcTabsGroupBehavior = new BcTabsGroupBehavior();
            bcTabsGroupBehavior.setElement(element);
            bcTabsGroupBehavior.setUp();
            elements.push(bcTabsGroupBehavior);
        }
        return elements;
    };
    BcTabsGroupBehavior.prototype._setUp = function () {
        this.initTabs();
    };
    BcTabsGroupBehavior.prototype.initTabs = function () {
        _super.prototype._setUp.call(this);
        this.container = this.mySelf;
        this.tabActiveBorder = this.mySelf;
        this.tabHeader = this.mySelf.querySelector(".".concat(bc_tabs_group_behavior_constants_17.TAB_HEADER_CLASS));
        this.tabsContainer = this.tabHeader.querySelector(":scope > .".concat(bc_tabs_group_behavior_constants_15.TAB_CONTAINER_CLASS));
        this.tabsArrowButtons = this.tabHeader.querySelector(":scope > .".concat(bc_tabs_group_behavior_constants_4.ARROW_BUTTONS));
        this.tabsPane = this.tabHeader.querySelectorAll(":scope .".concat(bc_tabs_group_behavior_constants_15.TAB_CONTAINER_CLASS, " > .").concat(bc_tabs_group_behavior_constants_14.TAB_CLASS));
        this.tabsLength = this.tabsPane.length;
        this.maxWidth = this.tabHeader.offsetWidth;
        this.base = 0;
        this.left = 0;
        this.tabBody = this.mySelf.querySelector(":scope > .".concat(bc_tabs_group_behavior_constants_13.TAB_BODY_CLASS));
        this.justifycontent =
            this.tabsContainer.getAttribute(JUSTIFY_CONTENT) != null
                ? this.tabsContainer.getAttribute(JUSTIFY_CONTENT)
                : SPACE_BETWEEN;
        this.orientation = this.tabsContainer.getAttribute(ORIENTATION);
        this.positionTabs();
        this.setColSize();
        this.addWindowListeners();
        this.initTabsGroup();
        this.addListenersArrows();
        this.createActiveborderTab();
    };
    BcTabsGroupBehavior.prototype.handleIndicator = function (activeTab) {
        var border = this.mySelf.querySelector(".".concat(bc_tabs_group_behavior_constants_2.TAB_BORDER_CLASS));
        border.style.width = "".concat(activeTab.offsetWidth, "px");
        border.style.left = "".concat(activeTab.offsetLeft, "px");
    };
    BcTabsGroupBehavior.prototype.createActiveborderTab = function () {
        var _this = this;
        this.tabsPane.forEach(function (tabElement) {
            tabElement.addEventListener('click', function (element) {
                tabElement.scrollIntoView({ inline: "center", behavior: "smooth", block: "nearest" });
                tabElement.classList.contains(bc_tabs_group_behavior_constants_3.TAB_REGULAR_CLASS) && _this.handleIndicator(element.currentTarget);
            });
            tabElement.classList.contains(bc_tabs_group_behavior_constants_1.ACTIVE_CLASS) && tabElement.classList.contains(bc_tabs_group_behavior_constants_3.TAB_REGULAR_CLASS) && _this.handleIndicator(tabElement);
        });
    };
    BcTabsGroupBehavior.prototype.addWindowListeners = function () {
        var _this = this;
        window.addEventListener(common_constants_1.BcCommonConstants.EVENT_LOAD, function () {
            _this.configureTabsWidth();
            _this.tabScrollPosition = 0;
            _this.onResizeFunction(window.innerWidth);
        });
        window.addEventListener(common_constants_1.BcCommonConstants.EVENT_RESIZE, function (e) {
            _this.tabScrollPosition = 0;
            _this.onResizeFunction(e.target.innerWidth);
        });
    };
    BcTabsGroupBehavior.prototype.callBackTabSelected = function (functionCallback) {
        this.onSelectTab = functionCallback;
    };
    BcTabsGroupBehavior.prototype.initTabsGroup = function () {
        var firstPane = this.tabsPane[0];
        var firstBody = this.tabBody.querySelectorAll(":scope > .".concat(bc_tabs_group_behavior_constants_16.TAB_CONTENT_CLASS))[0];
        firstPane.classList.add(bc_tabs_group_behavior_constants_1.ACTIVE_CLASS);
        firstBody !== undefined && firstBody.classList.add(bc_tabs_group_behavior_constants_1.ACTIVE_CLASS);
        for (var i = 0; i < this.tabsPane.length; i++) {
            var pane = this.tabsPane[i];
            this.addClickEventTab(pane, i);
            if (pane.className.includes('bc-tab-disabled')) {
                (0, helpers_1.addFocusable)(pane, { tabindex: '-1' });
            }
            else {
                (0, helpers_1.addFocusable)(pane, { tabindex: '0' });
            }
            this.screenReader(pane, i);
        }
        if (firstPane) {
            firstPane.click();
        }
    };
    BcTabsGroupBehavior.prototype.getCurrentIndexSelected = function () {
        return this.currentTabsSelected;
    };
    BcTabsGroupBehavior.prototype.onResizeFunction = function (innerWidth) {
        this.maxWidth = this.tabsContainer.offsetWidth;
        this.toggleNav(this.tabsArrowButtons, innerWidth);
        this.firsLoad = true;
        this.addListenersArrows();
        setTimeout(function () {
        }, bc_tabs_group_behavior_constants_18.FIVE_HUNDRED);
    };
    BcTabsGroupBehavior.prototype.setColSize = function () {
        if (this.mySelf.getAttribute('cols')) {
            var colSize = Number(this.mySelf.getAttribute('cols')) ? Number(this.mySelf.getAttribute('cols')) : bc_tabs_group_behavior_constants_20.TWELVE_NUMBER;
            if (colSize >= bc_tabs_group_behavior_constants_19.THREE_NUMBER && colSize <= bc_tabs_group_behavior_constants_20.TWELVE_NUMBER) {
                this.tabsContainer.classList.add('bc-col-' + colSize);
            }
            else {
                this.tabsContainer.classList.add('bc-col-12');
            }
        }
    };
    BcTabsGroupBehavior.prototype.positionTabs = function () {
        if (this.mySelf.getAttribute('right') && this.mySelf.getAttribute('right') === 'true') {
            this.tabsContainer.setAttribute(JUSTIFY_CONTENT, RIGHT_POSITION);
        }
        if (this.mySelf.getAttribute('left') && this.mySelf.getAttribute('left') === 'true') {
            this.tabsContainer.setAttribute(JUSTIFY_CONTENT, LEFT_POSITION);
        }
    };
    BcTabsGroupBehavior.prototype.toggleNav = function (tabsArrowButtons, innerWidth) {
        var ele = tabsArrowButtons;
        if (this.tabHeader.offsetWidth < this.getWidthAllTabs()) {
            ele.classList.remove(bc_tabs_group_behavior_constants_8.HIDE_CLASS);
            var tabs = this.tabsContainer.children;
            this.tabsContainer.setAttribute(JUSTIFY_CONTENT, LEFT_POSITION);
            if (tabs.length > bc_tabs_group_behavior_constants_5.FIVE_LENGTH) {
                this.base = bc_tabs_group_behavior_constants_12.SIX_LENGTH;
            }
            if (tabs.length < bc_tabs_group_behavior_constants_12.SIX_LENGTH) {
                this.base = bc_tabs_group_behavior_constants_6.FOUR_LENGTH;
            }
            if (innerWidth < bc_tabs_group_behavior_constants_10.MIN_WIDTH && tabs.length > bc_tabs_group_behavior_constants_5.FIVE_LENGTH) {
                this.base = bc_tabs_group_behavior_constants_6.FOUR_LENGTH;
            }
            if (innerWidth < bc_tabs_group_behavior_constants_9.MEDIUM_WIDTH && tabs.length > bc_tabs_group_behavior_constants_5.FIVE_LENGTH) {
                this.base = bc_tabs_group_behavior_constants_5.FIVE_LENGTH;
            }
            if (this.firsLoad) {
                this.firsLoad = false;
            }
        }
        else {
            ele.classList.add(bc_tabs_group_behavior_constants_8.HIDE_CLASS);
            this.tabsContainer.setAttribute(JUSTIFY_CONTENT, this.justifycontent);
            this.tabsContainer.style.left = '0';
        }
        this.maximumTabsLimit();
    };
    BcTabsGroupBehavior.prototype.maximumTabsLimit = function () {
        var tabsList = this.tabsContainer.getElementsByClassName('bc-tab');
        if (tabsList.length > bc_tabs_group_behavior_constants_7.SEVEN_NUMBER) {
            for (var i = tabsList.length - 1; i >= bc_tabs_group_behavior_constants_7.SEVEN_NUMBER; i--) {
                tabsList[i].remove();
            }
        }
    };
    BcTabsGroupBehavior.prototype.hideElement = function (element, displayString) {
        element.style.display = displayString;
    };
    BcTabsGroupBehavior.prototype.addListenersArrows = function () {
        var arrowButtons = Array.from(this.tabsArrowButtons.children);
        var tabsContainer = this.tabsContainer;
        var tabsContainerWidth = tabsContainer.clientWidth;
        var sumTabs = Array.from(this.tabsPane).reduce(function (a, b) {
            return a + b.clientWidth;
        }, 0);
        var prevArrow = arrowButtons[0];
        var nextArrow = arrowButtons[1];
        if (tabsContainerWidth >= sumTabs) {
            this.hideElement(prevArrow, 'none');
            this.hideElement(nextArrow, 'none');
        }
        else {
            this.hideElement(prevArrow, 'none');
            this.hideElement(nextArrow, '');
        }
        var horizontalScroll = this.tabHeader.clientWidth;
        prevArrow.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            tabsContainer.scrollLeft -= horizontalScroll / bc_tabs_group_behavior_constants_19.THREE_NUMBER;
        });
        nextArrow.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            tabsContainer.scrollLeft += horizontalScroll / bc_tabs_group_behavior_constants_19.THREE_NUMBER;
        });
        this.tabScrollListener(tabsContainer, arrowButtons);
        this.validateShowNextArrow(tabsContainer, arrowButtons);
    };
    BcTabsGroupBehavior.prototype.validateShowNextArrow = function (tabsContainer, arrowButtons) {
        var nextArrow = arrowButtons[1];
        var maximunScroll = tabsContainer.scrollWidth - this.tabHeader.clientWidth;
        maximunScroll - bc_tabs_group_behavior_constants_21.TWO_NUMBER <= tabsContainer.scrollLeft
            ? this.hideElement(nextArrow, 'none')
            : this.hideElement(nextArrow, '');
    };
    BcTabsGroupBehavior.prototype.tabScrollListener = function (tabsContainer, arrowButtons) {
        var _this = this;
        tabsContainer.addEventListener('scroll', function () {
            var prevArrow = arrowButtons[0];
            tabsContainer.scrollLeft == 0
                ? _this.hideElement(prevArrow, 'none')
                : _this.hideElement(prevArrow, '');
            _this.validateShowNextArrow(tabsContainer, arrowButtons);
        });
    };
    BcTabsGroupBehavior.prototype.screenReader = function (element, index) {
        var _this = this;
        element.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_UP, function (event) {
            if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_RIGHT) {
                _this.focusNext(index);
            }
            else if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_LEFT) {
                _this.focusBack(index);
            }
            else if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ENTER) {
                _this.focusEnter(index);
            }
            else if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_SPACE) {
                _this.focusEnter(index);
            }
        });
    };
    BcTabsGroupBehavior.prototype.focusNext = function (index) {
        var element = this.getCurrentElement(index);
        if (element !== null) {
            element.classList.remove(common_constants_1.BcCommonConstants.OUTLINE_ELEMENT);
            if (index < this.tabsPane.length - 1) {
                index++;
                element = this.getCurrentElement(index);
            }
            else {
                index = this.initialTab;
                element = this.getCurrentElement(index);
            }
            element.classList.add(common_constants_1.BcCommonConstants.OUTLINE_ELEMENT);
            element.focus();
        }
    };
    BcTabsGroupBehavior.prototype.focusBack = function (index) {
        var element = this.getCurrentElement(index);
        if (element !== null) {
            element.classList.remove(common_constants_1.BcCommonConstants.OUTLINE_ELEMENT);
            if (index > 0) {
                index--;
                element = this.getCurrentElement(index);
            }
            else {
                index = this.tabsPane.length - 1;
                element = this.getCurrentElement(index);
            }
            element.classList.add(common_constants_1.BcCommonConstants.OUTLINE_ELEMENT);
            element.focus();
        }
    };
    BcTabsGroupBehavior.prototype.focusEnter = function (index) {
        this.tabsPane[index].click();
    };
    BcTabsGroupBehavior.prototype.getCurrentElement = function (index) {
        return this.mySelf.querySelectorAll('.bc-tab')[index];
    };
    BcTabsGroupBehavior.prototype.addClickEventTab = function (pane, i) {
        var _this = this;
        pane.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            _this.removeAddClasses(pane, i);
            if (_this.onSelectTab) {
                _this.currentTabsSelected = i;
                _this.onSelectTab(_this.currentTabsSelected);
            }
        });
    };
    BcTabsGroupBehavior.prototype.removeAddClasses = function (pane, i) {
        var activeContainer = this.tabHeader.querySelectorAll(":scope .".concat(bc_tabs_group_behavior_constants_15.TAB_CONTAINER_CLASS, " > .").concat(bc_tabs_group_behavior_constants_1.ACTIVE_CLASS))[0];
        activeContainer !== undefined && activeContainer.classList.remove("".concat(bc_tabs_group_behavior_constants_1.ACTIVE_CLASS));
        var activeBody = this.tabBody.querySelectorAll(":scope > .".concat(bc_tabs_group_behavior_constants_1.ACTIVE_CLASS))[0];
        activeBody !== undefined && activeBody.classList.remove("".concat(bc_tabs_group_behavior_constants_1.ACTIVE_CLASS));
        pane !== undefined && pane.classList.add(bc_tabs_group_behavior_constants_1.ACTIVE_CLASS);
        var body = this.tabBody.querySelectorAll(":scope > .".concat(bc_tabs_group_behavior_constants_16.TAB_CONTENT_CLASS))[i];
        (0, helpers_1.addFocusable)(body, { tabindex: '0' });
        body !== undefined && body.classList.add(bc_tabs_group_behavior_constants_1.ACTIVE_CLASS);
    };
    BcTabsGroupBehavior.prototype.selectTab = function (index) {
        if (this.tabsPane[index]) {
            this.tabsPane[index].click();
        }
    };
    BcTabsGroupBehavior.prototype.configureTabsWidth = function () {
        var _this = this;
        this.tabsPane.forEach(function (element) {
            if (_this.orientation === 'vertical') {
                element.style.width = "100%";
            }
        });
    };
    BcTabsGroupBehavior.prototype.show = function (index) {
        var tab = this.getTabsHTMLObject(index);
        tab.title.style.display = 'block';
    };
    BcTabsGroupBehavior.prototype.hidden = function (index) {
        var tab = this.getTabsHTMLObject(index);
        tab.title.style.display = 'none';
        this.autoSelectTab(index);
    };
    BcTabsGroupBehavior.prototype.getTabsHTMLObject = function (index) {
        return {
            title: this.mySelf.querySelectorAll('.bc-tab')[index],
            body: this.mySelf.querySelectorAll('.bc-tab-content')[index],
        };
    };
    BcTabsGroupBehavior.prototype.autoSelectTab = function (indexHidden) {
        if (indexHidden == this.getCurrentIndexSelected()) {
            var nextTabIndex = indexHidden + 1;
            var prevTabIndex = indexHidden - 1;
            if (nextTabIndex < this.tabsLength) {
                this.selectTab(nextTabIndex);
            }
            else if (prevTabIndex > 0) {
                this.selectTab(prevTabIndex);
            }
        }
    };
    BcTabsGroupBehavior.prototype.getWidthAllTabs = function () {
        return Array.from(this.tabsPane)
            .map(function (a) { return a.offsetWidth; })
            .reduce(function (a, b) {
            return a + b;
        });
    };
    return BcTabsGroupBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcTabsGroupBehavior = BcTabsGroupBehavior;
